const MqttRouter = require('./lib/router');
const WrappedMQTTClient = require('./lib/wrappedMqttClient');
const utils = require('./lib/utils');
const middlewares = require('./lib/middleware');

// re-export relevant types

/** @template ExtraHandlerFuncArgs
 * @typedef {import('./lib/types').MessageHandlerFunc<ExtraHandlerFuncArgs>} MessageHandlerFunc>*/

/** @template ExtraHandlerFuncArgs
 * @typedef {import('./lib/types').MessageHandlerFuncArgs<ExtraHandlerFuncArgs>} MessageHandlerFuncArgs */

/** @template ExtraHandlerFuncArgs
 * @typedef {import('./lib/types').MqttMiddleware<ExtraHandlerFuncArgs>} MqttMiddleware*/

/**
 * @template ExtraHandlerFuncArgs
 * @param {import('./lib/types').Client} mqttClient
 * @param {Array<import('./lib/types').MqttMiddleware<ExtraHandlerFuncArgs>>} middlewares
 * @param {string} sharedGroup
 * @param {import('mqtt').IClientSubscribeOptions} defaultSubscriptionOptions
 * @returns {WrappedMQTTClient<ExtraHandlerFuncArgs>}
 */
function wrap(mqttClient, middlewares = [], sharedGroup = null, defaultSubscriptionOptions = null) {
	return new WrappedMQTTClient(mqttClient, middlewares, sharedGroup, defaultSubscriptionOptions);
}

module.exports = {
	utils,
	middlewares,
	wrap,
	MqttRouter,
	WrappedMQTTClient,
};
